// Browser detection utility
export const getBrowserInfo = () => {
    const ua = navigator.userAgent;
    let browserName = "Unknown";
    let browserVersion = "Unknown";
    let osName = "Unknown";
    let osVersion = "Unknown";

    // Detect Browser
    if (ua.indexOf("Firefox") > -1) {
        browserName = "Firefox";
        browserVersion = ua.match(/Firefox\/([0-9.]+)/)?.[1] || "Unknown";
    } else if (ua.indexOf("SamsungBrowser") > -1) {
        browserName = "Samsung Internet";
        browserVersion = ua.match(/SamsungBrowser\/([0-9.]+)/)?.[1] || "Unknown";
    } else if (ua.indexOf("Opera") > -1 || ua.indexOf("OPR") > -1) {
        browserName = "Opera";
        browserVersion = ua.match(/(?:Opera|OPR)\/([0-9.]+)/)?.[1] || "Unknown";
    } else if (ua.indexOf("Trident") > -1) {
        browserName = "Internet Explorer";
        browserVersion = ua.match(/rv:([0-9.]+)/)?.[1] || "Unknown";
    } else if (ua.indexOf("Edge") > -1) {
        browserName = "Edge (Legacy)";
        browserVersion = ua.match(/Edge\/([0-9.]+)/)?.[1] || "Unknown";
    } else if (ua.indexOf("Edg") > -1) {
        browserName = "Edge";
        browserVersion = ua.match(/Edg\/([0-9.]+)/)?.[1] || "Unknown";
    } else if (ua.indexOf("Chrome") > -1) {
        browserName = "Chrome";
        browserVersion = ua.match(/Chrome\/([0-9.]+)/)?.[1] || "Unknown";
    } else if (ua.indexOf("Safari") > -1) {
        browserName = "Safari";
        browserVersion = ua.match(/Version\/([0-9.]+)/)?.[1] || "Unknown";
    }

    // Detect OS
    if (ua.indexOf("Windows NT 10.0") > -1) {
        osName = "Windows";
        osVersion = "10";
    } else if (ua.indexOf("Windows NT 6.3") > -1) {
        osName = "Windows";
        osVersion = "8.1";
    } else if (ua.indexOf("Windows NT 6.2") > -1) {
        osName = "Windows";
        osVersion = "8";
    } else if (ua.indexOf("Windows NT 6.1") > -1) {
        osName = "Windows";
        osVersion = "7";
    } else if (ua.indexOf("Windows NT 6.0") > -1) {
        osName = "Windows";
        osVersion = "Vista";
    } else if (ua.indexOf("Windows NT 5.1") > -1) {
        osName = "Windows";
        osVersion = "XP";
    } else if (ua.indexOf("Mac OS X") > -1) {
        osName = "Mac OS X";
        osVersion = ua.match(/Mac OS X ([0-9_]+)/)?.[1]?.replace(/_/g, ".") || "Unknown";
    } else if (ua.indexOf("Android") > -1) {
        osName = "Android";
        osVersion = ua.match(/Android ([0-9.]+)/)?.[1] || "Unknown";
    } else if (ua.indexOf("iOS") > -1 || ua.indexOf("iPhone") > -1 || ua.indexOf("iPad") > -1) {
        osName = "iOS";
        osVersion = ua.match(/OS ([0-9_]+)/)?.[1]?.replace(/_/g, ".") || "Unknown";
    } else if (ua.indexOf("Linux") > -1) {
        osName = "Linux";
        osVersion = "";
    }

    // Detect Device Type
    let device = "Desktop";
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        device = "Tablet";
    } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        device = "Mobile";
    }

    return {
        browser: browserName,
        browserVersion: browserVersion,
        os: osName,
        osVersion: osVersion,
        device: device
    };
};
